import $ from 'jquery';

$(".icon-block").click(function () {
	$('html, body').animate({
		scrollTop: $(this).offset().top - 50
	}, 200);
});